export default "__VITE_ASSET__q6S6MAKp__"